import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "@/components/ui/sonner";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Method } from "@/components/landing/Method";
import { Curriculum } from "@/components/landing/Curriculum";
import { Graduates } from "@/components/landing/Graduates";
import { Cohorts } from "@/components/landing/Cohorts";
import { Pricing } from "@/components/landing/Pricing";
import { Venues } from "@/components/landing/Venues";
import { EnquiryForm } from "@/components/landing/EnquiryForm";
import { Footer } from "@/components/landing/Footer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Landing() {
  const [applicantType, setApplicantType] = useState("individual");
  const [paying, setPaying] = useState(null);
  const [cohorts, setCohorts] = useState([]);
  const [cohortsLoading, setCohortsLoading] = useState(true);
  const [selectedCohort, setSelectedCohort] = useState("feb-2027");

  useEffect(() => {
    axios
      .get(`${API}/cohorts`)
      .then(({ data }) => {
        setCohorts(data);
        if (data.length > 0) setSelectedCohort(data[0].id);
      })
      .catch(() => setCohorts([]))
      .finally(() => setCohortsLoading(false));
  }, []);

  const cohortLabel = cohorts.find((c) => c.id === selectedCohort)?.label;

  const handleEnquire = (type, cohortId) => {
    setApplicantType(type);
    if (cohortId) setSelectedCohort(cohortId);
    document.getElementById("enquire")?.scrollIntoView({ behavior: "smooth" });
  };

  const handlePay = async (lookupKey) => {
    setPaying(lookupKey);
    try {
      const { data } = await axios.post(`${API}/payments/checkout`, {
        lookup_key: lookupKey,
        origin_url: window.location.origin,
        cohort: selectedCohort,
      });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(
        "Could not start the secure checkout. Please try again or call +44 7479 815308."
      );
      setPaying(null);
    }
  };

  return (
    <div
      data-testid="landing-page"
      className="bg-linen text-ink antialiased font-sans min-h-screen overflow-x-hidden selection:bg-forest selection:text-linen"
    >
      <Nav />
      <Hero />
      <Marquee />
      <Method />
      <Curriculum />
      <Graduates />
      <Cohorts
        cohorts={cohorts}
        loading={cohortsLoading}
        selectedCohort={selectedCohort}
        onSelect={setSelectedCohort}
        onEnquire={(cohortId) => handleEnquire(applicantType, cohortId)}
      />
      <Pricing onPay={handlePay} onEnquire={handleEnquire} paying={paying} cohortLabel={cohortLabel} />
      <Venues />
      <EnquiryForm
        applicantType={applicantType}
        setApplicantType={setApplicantType}
        cohorts={cohorts}
        cohort={selectedCohort}
        setCohort={setSelectedCohort}
      />
      <Footer />
    </div>
  );
}
